import React from 'react';
import { Modal, Form, Button } from '@deere/ux.uxframe-react';
import { useHistory } from 'react-router';
import { useTranslation } from "react-i18next";

export const ModalSubmit = ({showModal, setShowModal, titleKey, messageKey, doNotNavidate, buttonKey, navigateTo }) => {
    
    const history = useHistory()
    const { t } = useTranslation();

    function acceptSubmit() {
        if (!doNotNavidate) {
          setShowModal(false);
          history.push({
            pathname: navigateTo && navigateTo !== "" ? navigateTo : "/",
            state: { previous: history?.location?.pathname },
          });
        }
      }
    
    return (
        <Modal show={showModal} onHide={acceptSubmit}>
        <Modal.Header>
            <Modal.Title>{t(titleKey)}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="overflow-hidden">
            <Form.Group>
                <Form.Label style={{ fontWeight: 'bold' }}>
                    {t(messageKey)}
                </Form.Label>
            </Form.Group>
        </Modal.Body>
        {!doNotNavidate && <Modal.Footer>
            <Button
                value={t('btn_accept_submit')}
                type="submit"
                variant="primary"
                onClick={acceptSubmit}
            >
                {t(buttonKey)}
            </Button>
        </Modal.Footer>}
    </Modal>
    )
}